import type { ReactNode } from 'react'
import { ThemeProvider as NextThemesProvider } from 'next-themes'

/**
 * Wraps the app in class-based theming. `attribute="class"` toggles the `.dark`
 * class consumed by the design tokens in `globals.css`. Light is the default;
 * the OS preference is intentionally not followed so the app opens light unless
 * the user explicitly switches.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  )
}
